import { useLocation } from 'react-router-dom';
import { LocationState, SurveyContainerStep } from '../../survey-container/types';
import { SurveyAccount } from '@myriadgenetics/mgh-types';
import { getUrlSlug, isChatbotUrl } from '../../../helpers/url';
import { useHistory } from '../../../helpers/routing';
import { startState } from '../../survey-container/utils';

export const useSetProvider = () => {
  const history = useHistory();
  const location = useLocation() as LocationState;
  const urlSlug = getUrlSlug(location.state?.mghUrl, location).toLowerCase();

  const setProvider = (surveyAccount: SurveyAccount | undefined, clinicName: string | null, doContinue: boolean, doReplace = false) => {
    const method = doReplace ? history.replace : history.push;
    const additionalState = doReplace ? startState(history) : {};
    const surveyAccountAndContinue = doContinue ? surveyAccount : undefined;

    // Virtual care surveys are triggered on the fetch step and when we have a surveyId
    // This complex check is to allow the Virtual care survey to start, and to allow the clinic and provider selects to co-exist.
    // TODO: Handle Virtual care initialization in a more elegant way
    const nextSurveyStep =
      !isChatbotUrl(urlSlug) && doReplace && surveyAccountAndContinue === undefined ? SurveyContainerStep.Provider : SurveyContainerStep.Fetch;

    method(`/${urlSlug}/provider`, {
      ...location.state,
      surveyAccount,
      surveyStep: nextSurveyStep,
      survey: undefined,
      nodeId: undefined,
      locResponses: { ...location.state?.initData, ...location.state?.locResponses },
      clinicName,
      ...additionalState,
    });
  };

  return setProvider;
};

export default { useSetProvider };
